import React, { useEffect } from "react";
import { Col, Container, Row } from "react-bootstrap";
import { isMobile } from "react-device-detect";
import PackageCard from "./Component/PackageCard";
import CountdownTimer from "./Component/Counter";
import ApiAmusementPackage from "../../../core/api/api.amusementPackage";
import { useState } from "react";
import { useLocation } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import Skeleton, { SkeletonTheme } from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import _ from "lodash";
import PackageCardSkeleton from "./Component/PackageCardSkeleton";
function AmusementPackage() {
  const location = useLocation();
  const [amusementPackages, setAmusementPackages] = useState([]);
  const [services, setServices] = useState([]);
  const [pageContent, setPageContent] = useState();
  const [loadingData, setLoadingData] = useState(false);
  const loadingDataDefault = [1, 2, 3];
  // const data = [
  //   {
  //     id: "1",
  //     expireDate: "1403/11/10 12:30:00",
  //     title: "پکیج تفریحات هیجانی کیش",

  //     capacity: "10",
  //     soldOut: "5",
  //     packageItem: [
  //       {
  //         id: "1",
  //         itemName: "کشتی آکواریومی",
  //         //itemImageUrl: require("../../../assets/images/amusement/aquariumship8.jpg"),
  //         price: "330000",
  //         finalPrice: "300000",
  //       },
  //       {
  //         id: "2",
  //         itemName: "پدل برد",
  //         //itemImageUrl: require("../../../assets/images/amusement/padelboard6003.jpg"),
  //         price: "545000",
  //         finalPrice: "500000",
  //       },
  //       {
  //         id: "3",
  //         itemName: "پاراسل",
  //         //itemImageUrl: require("../../../assets/images/amusement/parasel1007.jpg"),
  //         price: "660000",
  //         finalPrice: "600000",
  //       },
  //       {
  //         id: "4",
  //         itemName: "شاتل",
  //         //itemImageUrl: require("../../../assets/images/amusement/shatel2.jpg"),
  //         price: "220000",
  //         finalPrice: "200000",
  //       },
  //       {
  //         id: "5",
  //         itemName: "پارک دلفین",
  //         // itemImageUrl: require("../../../assets/images/amusement/dolphinpark1036.jpg"),
  //         price: "850000",
  //         finalPrice: "800000",
  //       },
  //     ],
  //   },
  //   {
  //     id: "2",
  //     expireDate: "1403/11/08 23:00:00",
  //     title: "پکیج تفریحات خانوادگی کیش",

  //     capacity: "8",
  //     soldOut: "3",
  //     packageItem: [
  //       {
  //         id: "6",
  //         itemName: "کشتی آکواریومی",
  //         //itemImageUrl: require("../../../assets/images/amusement/aquariumship8.jpg"),
  //         price: "330000",
  //         finalPrice: "300000",
  //       },
  //       {
  //         id: "7",
  //         itemName: "سافاری",
  //         //itemImageUrl: require("../../../assets/images/amusement/paintball1044001.jpg"),
  //         price: "250000",
  //         finalPrice: "187000",
  //       },
  //       {
  //         id: "8",
  //         itemName: "جنگ رنگارنگ",
  //         // itemImageUrl: require("../../../assets/images/amusement/puzellshow20004.jpg"),
  //         price: "390000",
  //         finalPrice: "370000",
  //       },
  //       {
  //         id: "9",
  //         itemName: "پارک دلفین",
  //         // itemImageUrl: require("../../../assets/images/amusement/dolphinpark1036.jpg"),
  //         price: "850000",
  //         finalPrice: "800000",
  //       },
  //     ],
  //   },
  //   {
  //     id: "3",
  //     expireDate: "1403/11/07 23:59:00",
  //     title: "پکیج ماه عسل کیش",
  //     capacity: "5",
  //     soldOut: "1",
  //     packageItem: [
  //       {
  //         id: "10",
  //         itemName: "پاراسل",
  //         //itemImageUrl: require("../../../assets/images/amusement/parasel1007.jpg"),
  //         price: "660000",
  //         finalPrice: "600000",
  //       },
  //       {
  //         id: "12",
  //         itemName: "کشتی تفریحی خصوصی",
  //         itemImageUrl: require("../../../assets/images/amusement/privatecruiseship17006.jpg"),
  //         price: "3500000",
  //         finalPrice: "2700000",
  //       },
  //       {
  //         id: "13",
  //         itemName: "تونل باد",
  //         itemImageUrl: require("../../../assets/images/amusement/telekabin116.jpg"),
  //         price: "1970000",
  //         finalPrice: "1750000",
  //       },
  //       {
  //         id: "14",
  //         itemName: " رستوران میرمهنا",
  //         itemImageUrl: require("../../../assets/images/amusement/mirmohana1009001.jpg"),
  //         price: "80000",
  //         finalPrice: "70000",
  //       },
  //     ],
  //   },
  // ];

  useEffect(() => {
    getData();
  }, []);

  async function getData() {
    setLoadingData(true);
    try {
      const packageResult = await ApiAmusementPackage.getAmusementPackages();
      // console.log("data==", packageResult);
      setAmusementPackages(packageResult.result.amusementPackages);
      setServices(packageResult.result.amusementServices);
      setPageContent(packageResult.result.pageContent);
    } catch (error) {
      setLoadingData(false);
    } finally {
      setLoadingData(false);
    }
  }
  return (
    <>
      <div className="wrapper">
        {!_.isNil(pageContent) ? (
          <Helmet>
            <link
              rel="canonical"
              href={window.location.origin + location.pathname}
            ></link>
            <meta
              property="og:url"
              content={window.location.origin + location.pathname}
            />
            <title>{pageContent?.pageTitle}</title>
            <meta property="og:title" content={pageContent?.pageTitle} />
            <meta
              property="og:description"
              content={pageContent?.metaDescription}
            />
            <meta name="description" content={pageContent?.metaDescription} />
          </Helmet>
        ) : (
          ""
        )}
      </div>
      <Container fluid className="main-content">
        <Container className="pt-4 px-0">
          <Row>
            <Col xs="12" className="py-3 text-center">
              {loadingData ? (
                <SkeletonTheme>
                  <Skeleton height="15px"></Skeleton>
                </SkeletonTheme>
              ) : (
                <h1 className="fs-101 fw-bold text-line light-text-line bg-light-text-line">
                  <span className="px-lg-3 bg-light-text-line">
                    {pageContent?.h1}
                  </span>
                </h1>
              )}

              <p className="fs-075 d-flex align-items-center justify-content-center mb-2">
                1403/11/01<span className="px-1">-</span> 1403/11/20
                <span className="px-1"></span>
                <CountdownTimer targetDate="1403/11/20 00:00:00" />
              </p>
            </Col>
          </Row>
          <Row className="gx-3">
            {loadingData
              ? loadingDataDefault?.map((item, index) => (
                  <Col
                    key={index}
                    xs="12"
                    sm="8"
                    md="6"
                    xl="4"
                    className="mx-auto mx-md-0 mb-3"
                  >
                    <PackageCardSkeleton />
                  </Col>
                ))
              : amusementPackages.length > 0 &&
                services.length > 0 &&
                amusementPackages?.map((item, index) => (
                  <Col
                    xs="12"
                    sm="8"
                    md="6"
                    xl="4"
                    className="mx-auto mx-md-0 mb-3"
                  >
                    <PackageCard key={index} data={item} services={services} />
                  </Col>
                ))}
          </Row>
        </Container>
      </Container>
    </>
  );
}
export default AmusementPackage;
